(function() {
  require(["jquery", "underscore", "commons/chartServices", "commons/circulationCharts", "dataTables", "bootstrap-collapse"], function($, _, chartServices, circulationCharts) {
    return $(function() {
      var dataTable, dataTableSettings, dataTableSettingsDigital, isPrint;
      if ($("#CirculationType").val() === "print") {
        isPrint = true;
      }
      if (!isPrint) {
        circulationCharts.executeDigital();
      } else {
        circulationCharts.executePrintHistorical();
        circulationCharts.executePrintSubscription();
      }
      $.extend($.fn.dataTableExt.oSort, {
        "formatted-num-pre": function(a) {
          var x;
          if (a === null || a.length === 0) {
            return 0;
          }
          x = a.replace(/[\s&nbsp;]+/g, "");
          return parseFloat(x);
        },
        "formatted-num-asc": function(a, b) {
          if (a < b) {
            return -1;
          } else if (a > b) {
            return 1;
          } else {
            return 0;
          }
        },
        "formatted-num-desc": function(a, b) {
          if (a < b) {
            return 1;
          } else if (a > b) {
            return -1;
          } else {
            return 0;
          }
        }
      });
      dataTableSettings = {
        sDom: "t",
        bPaginate: false,
        bInfo: false,
        bAutoWidth: false,
        aaSorting: [[1, "desc"], [0, "asc"], [2, "asc"]]
      };
      dataTableSettingsDigital = {
        sDom: "t",
        bPaginate: false,
        bInfo: false,
        bAutoWidth: false,
        aaSorting: [[2, "desc"], [0, "asc"], [1, "desc"]]
      };
      dataTable = $("#digital-circulation").dataTable($.extend({}, dataTableSettingsDigital, {
        aoColumns: [
          null, null, null, null, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }
        ]
      }));
      $("#dailies2013-table").dataTable($.extend({}, dataTableSettings, {
        aoColumns: [
          null, null, null, null, null, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }
        ]
      }));
      $("#dailies-table").dataTable($.extend({}, dataTableSettings, {
        aoColumns: [
          null, null, null, null, null, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }
        ]
      }));
      $("#dailies-simplified-table").dataTable($.extend({}, dataTableSettings, {
        aoColumns: [
          null, null, null, null, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }
        ]
      }));
      $("#periodicals2013-table").dataTable($.extend({}, dataTableSettings, {
        aoColumns: [
          null, null, null, null, null, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }
        ]
      }));
      $("#periodicals-table").dataTable($.extend({}, dataTableSettings, {
        aoColumns: [
          null, null, null, null, null, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }
        ]
      }));
      $("#periodicals-simplified-table").dataTable($.extend({}, dataTableSettings, {
        aoColumns: [
          null, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }
        ]
      }));
      $("#freepapers-table").dataTable($.extend({}, dataTableSettings, {
        aoColumns: [
          null, null, null, null, null, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, null, null
        ]
      }));
      $("#simplifiedpapers-table").dataTable($.extend({}, dataTableSettings, {
        aoColumns: [
          null, null, null, null, null, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, {
            sType: "formatted-num",
            asSorting: ["desc", "asc"]
          }, null
        ]
      }));
      $(".unit-names").change(function() {
        return dataTable.fnFilter(this.value, 1, false, false);
      }).change();
      return $(".years").change(function() {
        var currentPath;
        currentPath = window.location.href.split("?")[0];
        return window.location.href = currentPath + ("?year=" + (encodeURIComponent(this.value)));
      });
    });
  });

}).call(this);

//# sourceMappingURL=app.js.map
;
define("Apps/Circulation/script/app", function(){});

